import banner403 from '@treneo/assets/images/banner-403.svg';
import { useAppTranslations } from '@treneo/shared/i18n';
import { useAppNavigate } from '@treneo/shared/router';
import { Colors, Spacing } from '@treneo/shared/themes';

import { CloseIconButton } from './buttons/close-icon-button';
import { SingleLine } from './components/single-line';
import { Typography } from './components/typography';
import {
  ButtonLink,
  LeftColumn,
  StyledContainer,
  StyledMuiLink,
  Wrapper
} from './not-found-page/not-found-page.styles';
import { Link } from './link';
import { styled } from './styled';

const StyledImg = styled('img')`
  max-height: 450px;
`;

const StyledCloseButton = styled(CloseIconButton)`
  position: absolute !important;
  top: ${Spacing.small};
  right: ${Spacing.small};
`;

export const ForbiddenPage = () => {
  const { t } = useAppTranslations();
  const navigate = useAppNavigate();

  const handleBackClick = () => window.history.back();
  const handleCloseClick = () => navigate('/');

  return (
    <StyledContainer>
      <Wrapper>
        <LeftColumn>
          <Typography>{t('forbiddenPage.title')}</Typography>
          <Typography fontSize='164px' fontWeight={700} color={Colors.black}>
            403
          </Typography>
          <Typography>{t('forbiddenPage.firstLine')}</Typography>
          <SingleLine>
            <ButtonLink onClick={handleBackClick}>{t('forbiddenPage.backButton')}</ButtonLink>
            <Typography>{t('forbiddenPage.secondLine')}</Typography>
            <Link to='/' label={t('forbiddenPage.mainPage')} />
          </SingleLine>
          <SingleLine>
            <Typography>{t('forbiddenPage.thirdLine')}</Typography>
            <StyledMuiLink href='mailto:kontakt@treneo.pl'>kontakt@treneo.pl</StyledMuiLink>
          </SingleLine>
        </LeftColumn>
        <StyledImg src={banner403} alt='banner 403'></StyledImg>
        <StyledCloseButton onClose={handleCloseClick} />
      </Wrapper>
    </StyledContainer>
  );
};
